//Promo standard
var promoStandard = $('.promo-standard');

function promoStandardInit() {
  $('.promo-card-title').css('height','auto');
  $('.promo-card-description').css('height','auto');
  var maxHeight = null;
  var maxHeight2 = null;
  var promoCardTitle = $('.promo-card-title');
  var promoCardDesc = $('.promo-card-description');
  promoCardTitle.each(function() {
    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
  });
  promoCardTitle.each(function() {
    if (window.innerWidth >= 768) {
      $(this).height(maxHeight);
    } else {
      $(this).height("initial");
    }
  });
  promoCardDesc.each(function() {
    maxHeight2 = maxHeight2 > $(this).height() ? maxHeight2 : $(this).height();
  });
  promoCardDesc.each(function() {
    if (window.innerWidth >= 768) {
      $(this).height(maxHeight2);
    }
    else{
      $(this).height("initial");
    }
  });
}

if(promoStandard.length > 0) {
  promoStandardInit();
  $(window).resize(function () {
    promoStandardInit();
  });
}

//Promo Grid
var promoGrid = $('.promo-grid');

function promoGridInit() {
  var promogriditemdescription = $('.promo-grid-item-description');
  var promogriditemtitle = $('.promo-grid-item-title');
  promogriditemdescription.css('height','auto');
  promogriditemtitle.css('height','auto');
  var maxHeight = null;
  var maxHeight2 = null;
  promogriditemdescription.each(function() {
    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
  });
  promogriditemdescription.each(function() {
    if (window.innerWidth >= 768) {
      $(this).height(maxHeight);
    }
    else{
      $(this).height("initial");
    }
  });
  promogriditemtitle.each(function() {
    maxHeight2 = maxHeight2 > $(this).height() ? maxHeight2 : $(this).height();
  });
  promogriditemtitle.each(function() {
    if (window.innerWidth >= 768) {
      $(this).height(maxHeight2);
    } else {
      $(this).height("initial");
    }
  });
}

if(promoGrid.length > 0) {
  promoGridInit();
  $(window).resize(function () {
    promoGridInit();
  });
}
